import { useEffect } from 'react';

function PaypalSuccess() {

    useEffect(() => {
        console.log("Payment successful - handling success");

        // Retrieve the order data from sessionStorage
        const storedOrderData = JSON.parse(sessionStorage.getItem('orderData'));
        console.log("Stored Order Data:", storedOrderData);

        if (storedOrderData) {
            // Clear sessionStorage to avoid reusing stale data
            sessionStorage.removeItem('orderData');
            
            // Optionally, call the parent window's onContinue function if available
            if (window.opener && typeof window.opener.onContinue === 'function') {
                window.opener.onContinue(); // Call the parent window function
            }

            // Optionally, close the current window after completing the order
            window.close(); // Close the PayPal success window
        } else {
            console.error('No order data found in sessionStorage!');
        }
    }, []); // Empty dependency array to ensure it runs only once when the component mounts

    return (
        <div>
            <h2>Payment Successful</h2>
            <p>Your payment has been processed successfully. You will be redirected shortly.</p>
        </div>
    );
}

export default PaypalSuccess;
